









import Vue from 'vue';
import { IFooterIconsComponent } from '../../../common/interfaces/footer.interface';
import TIcons from '../../../types/TIcons';

export default Vue.extend({
  name: `PaymentLogo`,
  data(): IFooterIconsComponent {
    return {
      icons: TIcons,
    };
  },
  props: {
    logo: {
      required: true,
      type: String,
    },
  },
});
